import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import PillButton from '../buttons/Pill';

import styles from '../../../styles/menus/pills-menu.module.scss';

const propTypes = {
    className: PropTypes.string,
    items: AppPropTypes.menuItems,
    pillClassName: PropTypes.string,
    isDark: PropTypes.bool,
    onClick: PropTypes.func,
};

const defaultProps = {
    className: null,
    items: [],
    pillClassName: null,
    isDark: false,
    onClick: null,
};

const PillsMenu = ({ className, items, pillClassName, isDark, onClick }) => (
    <nav
        className={classNames(styles.container, {
            [className]: className !== null,
        })}
    >
        {(items || []).map(({ id = null, label = null, value, hash, active }, index) => (
            <div className={styles.item} key={`pill-${index + 1}`}>
                <PillButton
                    onClick={() => onClick({ id, value, hash })}
                    active={active}
                    isDark={isDark}
                    className={pillClassName}
                >
                    {label !== null ? <span className={styles.label}>{label}</span> : index + 1}
                </PillButton>
            </div>
        ))}
    </nav>
);

PillsMenu.propTypes = propTypes;
PillsMenu.defaultProps = defaultProps;

export default PillsMenu;
